module.exports = __webpack_public_path__ + "img/difficulty_2.8a9d96c9.png";